export default function $exceptionHandler($injector) {
	"ngInject";

	return (ex, cause) => {
		if (!ex || !angular.isString(ex) || ex.indexOf('"status":500') !== -1) {
			let NotificationService = $injector.get("NotificationService");
			NotificationService.exception()(ex, cause);
		} else if (!ex || !angular.isString(ex) || ex.indexOf('"status":502') !== -1) {
			let NotificationService = $injector.get("NotificationService");
			NotificationService.exception()(ex, 'pros-maps.error.502');
		} else if (!ex || !angular.isString(ex) || ex.indexOf('multiMissionUserReadOnlyException') !== -1) {
			let NotificationService = $injector.get("NotificationService");
			NotificationService.exception()(ex, 'pros-maps.error.multiMissionUserReadOnlyException');
		}
	};
}
